import { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import toast from 'react-hot-toast'
import { useSearchParams } from 'react-router-dom'
import { useUpdateEffect } from 'react-use'
import { ReactZoomPanPinchContentRef, TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'

import { verityRoorunWorkflowByCourseIdmUser } from '@/api/room2'
import test1Img from '@/assets/images/1.png'
import test2Img from '@/assets/images/2.png'
import test3Img from '@/assets/images/3.png'
import test4Img from '@/assets/images/4.png'
import test5Img from '@/assets/images/5.png'
import test6Img from '@/assets/images/6.png'
import test7Img from '@/assets/images/7.png'
import magicIcon from '@/assets/images/room2/magic.gif'
import Modal from '@/components/Modal'
import useObjState from '@/hooks/useObjState'
import Rtc, { MediaType, RemoteUser } from '@/utils/rtc'
import uploadClient from '@/utils/upload-client'

export const rtcClient = new Rtc()

export interface Assistant {
  error_guide_url: string
  error_tip: string
  match_errorId: string
  match_errorName: string
  match_errorReason: string
}

let timer: any = null

export default function Index() {
  const [searchParams] = useSearchParams()
  const open = useObjState(false) // 魔法弹窗
  const isStart = useObjState(false) // 是否开始
  const screenshotUploadControl = useObjState(false) // 截图上传控制
  const countdown = useObjState(0) // 倒计时
  const assistantList = useObjState<Assistant[]>([]) // 步骤列表
  const chooseAssistantIndex = useObjState(0) // 选择步骤索引
  const controller = useRef<AbortController | null>(null)
  const transformRef = useRef<ReactZoomPanPinchContentRef | null>(null)

  useEffect(() => {
    init()
    if (!localStorage.COUNTDOWN_SECONDS) {
      localStorage.COUNTDOWN_SECONDS = 120
    }

    return () => {
      rtcClient.destroy()
    }
  }, [])

  const init = async () => {
    rtcClient.ready('agora')

    const channel = searchParams.get('channel') || 'zujiao-001'
    const uid = searchParams.get('uid') || 10001

    await rtcClient.init({
      channel: channel,
      uid: Number(uid)
    })

    const cameras = await Rtc.getCameras()
    console.log('cameras', cameras)

    const cameraIndex = Number(searchParams.get('camera') || '0')

    await rtcClient.changeMainCamera({
      deviceId: cameras[cameraIndex].deviceId,
      publish: false,
      canvas: false
    })
  }

  useEffect(() => {
    console.log('loadd Studdent video')
    // 远端和本地视频

    rtcClient.on('media-ready', localPlay)
    rtcClient.on('media-close', unLocalPlay)
    return () => {
      rtcClient.removeListener('mute-video', unLocalPlay)
      rtcClient.removeListener('mute-audio', unLocalPlay)
    }
  }, [])

  // 本地音视频播放
  const localPlay = useCallback((mediaType: MediaType, user: RemoteUser) => {
    console.log('mediaType', mediaType, user)
    if (mediaType === 'video') {
      const ele = document.querySelector<HTMLElement>(`#video_dom`) as HTMLElement
      if (ele && user.videoTrack) {
        ele.innerHTML = ''
        rtcClient.play(user.videoTrack, ele, { fit: 'cover', mirror: false, type: 'local' })
      }
    }
  }, [])

  // 本地音视频关闭
  const unLocalPlay = useCallback((mediaType: MediaType, user: { uid: number }, code?: number) => {
    if (mediaType === 'video') {
      const ele = document.querySelector<HTMLElement>(`#video_dom`) as HTMLElement
      ele.innerHTML = ''
    }
  }, [])

  const start = useCallback(() => {
    isStart.set(true)
    open.set(false)
  }, [])

  const exit = useCallback(() => {
    isStart.set(false)
    assistantList.set([])
    setTimeout(() => {
      controller.current?.abort()
    }, 100)
  }, [])

  useEffect(() => {
    screenshotUploadControl.set(isStart.val)
  }, [isStart.val])

  useUpdateEffect(() => {
    if (screenshotUploadControl.val) {
      countdown.set(Number(localStorage.COUNTDOWN_SECONDS))
    } else {
      countdown.set(0)
    }
  }, [screenshotUploadControl.val])

  // 倒计时逻辑
  useEffect(() => {
    if (countdown.val > 0) {
      timer = setInterval(() => {
        countdown.set((prev) => {
          if (prev <= 1) {
            // 倒计时结束，执行截图
            if (timer) {
              clearInterval(timer)
              timer = null
            }
            captureAndUploadScreenshot()
            return 0
          }
          return prev - 1
        })
      }, 1000)

      return () => {
        if (timer) {
          clearInterval(timer)
          timer = null
        }
      }
    }
  }, [countdown.val])

  const chooseAssistant = useMemo(() => {
    return assistantList.val[chooseAssistantIndex.val]
  }, [assistantList, chooseAssistantIndex.val])

  // 切换步骤时重置图片状态
  useUpdateEffect(() => {
    if (transformRef.current) {
      transformRef.current.resetTransform()
    }
  }, [chooseAssistantIndex.val])

  const handleTransformInit = (ref: ReactZoomPanPinchContentRef) => {
    transformRef.current = ref
  }

  // useUpdateEffect(() => {
  //   if (assistantList.val.length === 0) {
  //     setScreenshotUploadControl(true)
  //   }
  // }, [assistantList])

  // 截图并上传
  const captureAndUploadScreenshot = useCallback(async () => {
    // const res = {
    //   status: 0,
    //   msg: '数据访问成功',
    //   data: {
    //     status: 0,
    //     msg: 'ok',
    //     data: '{"task_id": "6f5ed4f4-85b4-4753-846f-31d59e85a17f", "workflow_run_id": "bfa838bc-1a5d-4286-bc7a-6736ddfddf93", "data": {"id": "bfa838bc-1a5d-4286-bc7a-6736ddfddf93", "workflow_id": "a232a07d-7535-4f03-8db8-370bc8746468", "status": "succeeded", "outputs": {"result": [{"match_errorId": "error01", "match_errorName": "\\u6784\\u56fe\\u4f4d\\u7f6e\\u592a\\u504f", "match_errorReason": "\\u4f5c\\u54c1\\u4e2d\\u6b63\\u65b9\\u4f53\\u4f4d\\u7f6e\\u504f\\u5de6\\uff0c\\u4f7f\\u753b\\u9762\\u5931\\u8861", "error_tip": "\\u544a\\u8bc9\\u5b66\\u751f\\u8981\\u628a\\u4e3b\\u4f53\\u7269\\u653e\\u5728\\u7eb8\\u9762\\u4e0a\\u7684\\u9ec4\\u91d1\\u5206\\u5272\\u70b9\\uff0c\\u5e76\\u4e14\\u4eae\\u90e8\\u7684\\u671d\\u5411\\u548c\\u7eb8\\u8fb9\\u7f18\\u8ddd\\u79bb\\u8981\\u5927\\u4e8e\\u6697\\u90e8\\u671d\\u5411\\u548c\\u7eb8\\u8fb9\\u7f18\\u7684\\u8ddd\\u79bb\\u3002", "error_guide_url": "https://msb-wangxiao.oss-cn-beijing.aliyuncs.com/course/1000/image/error_01_guide.png"}, {"match_errorId": "error02", "match_errorName": "\\u6784\\u56fe\\u592a\\u5927\\u6216\\u592a\\u5c0f", "match_errorReason": "\\u6b63\\u65b9\\u4f53\\u5360\\u636e\\u753b\\u9762\\u8fc7\\u6ee1\\uff0c\\u538b\\u8feb\\u611f\\u5f3a", "error_tip": "\\u544a\\u8bc9\\u5b66\\u751f\\u6784\\u56fe\\u8981\\u9971\\u6ee1\\uff0c\\u5927\\u5c0f\\u8981\\u7f8e\\u89c2\\uff0c\\u4e00\\u822c\\u8981\\u5360\\u753b\\u9762\\u4e09\\u5206\\u4e4b\\u4e00\\u7684\\u5927\\u5c0f\\u3002", "error_guide_url": "https://msb-wangxiao.oss-cn-beijing.aliyuncs.com/course/1000/image/error_01_guide.png"}, {"match_errorId": "error03", "match_errorName": "\\u8d77\\u5f62\\u6bd4\\u4f8b\\u9519\\u8bef", "match_errorReason": "\\u4e09\\u4e2a\\u9762\\u4e4b\\u95f4\\u7684\\u957f\\u5bbd\\u6bd4\\u4f8b\\u4e0d\\u5bf9\\uff0c\\u524d\\u9762\\u592a\\u5bbd\\u3001\\u4fa7\\u9762\\u592a\\u7a84\\u3001\\u4e0d\\u7b26\\u5408\\u7acb\\u4f53\\u6548\\u679c", "error_tip": "\\u7acb\\u65b9\\u4f53\\u7684\\u6bd4\\u4f8b\\u4e3b\\u8981\\u662f\\u9762\\u548c\\u9762\\u4e4b\\u95f4\\u7684\\u5927\\u5c0f\\u6bd4\\u4f8b\\uff0c\\u7acb\\u65b9\\u4f53\\u9762\\u548c\\u9762\\u4e4b\\u95f4\\u7684\\u5927\\u5c0f\\u5bf9\\u6bd4\\u53ef\\u4ee5\\u89c2\\u5bdf\\u3001\\u6bd4\\u8f83\\u5b9e\\u9645\\u7269\\u4f53\\u53bb\\u786e\\u8ba4\\u3002", "error_guide_url": "https://msb-wangxiao.oss-cn-beijing.aliyuncs.com/course/1000/image/error_01_guide.png"}]}, "error": "", "elapsed_time": 12.56874, "total_tokens": 0, "total_steps": 8, "created_at": 1760514580, "finished_at": 1760514593}}'
    //   }
    // }

    // if (res.status === 0) {
    //   const data = res.data.data
    //   const fixData = JSON.parse(data)
    //   console.log('fixData', fixData)
    //   if ('result' in fixData.data.outputs && fixData.data.outputs.result.length > 10) {
    //     console.log('fixData.data.outputs.result', fixData.data.outputs.result)
    //     setAassistantList(fixData.data.outputs.result)

    //     // 截图完成后，将控制状态设置为false
    //     setScreenshotControl(false)
    //     isCapturingRef.current = false
    //   } else {
    //     console.log('重新截图')
    //     setScreenshotControl(true)
    //     isCapturingRef.current = false
    //   }
    // } else {
    //   toast.error(res.msg)
    // }
    // return

    const videoMainDom = document.querySelector(`#video_dom`) as Element
    const videoDom = videoMainDom?.querySelector('video') as HTMLVideoElement

    if (!videoDom) {
      console.log('「截图上传」未找到视频元素')
      return
    }

    const canvas = document.createElement('canvas')
    const context: any = canvas.getContext('2d')

    // 原视频尺寸
    const videoWidth = videoDom.videoWidth
    const videoHeight = videoDom.videoHeight

    // 目标比例 3:4 (宽:高)
    const targetRatio = 3 / 4

    // 保持高度100%，计算目标宽度
    const targetHeight = videoHeight
    const targetWidth = targetHeight * targetRatio

    // 设置canvas尺寸为目标尺寸
    canvas.width = targetWidth
    canvas.height = targetHeight

    // 计算从原图中间裁剪的区域
    let sourceX = 0
    const sourceY = 0
    let sourceWidth = videoWidth
    const sourceHeight = videoHeight

    // 如果原视频宽度大于目标宽度，则从中间裁剪
    if (videoWidth > targetWidth) {
      sourceWidth = targetWidth
      sourceX = (videoWidth - targetWidth) / 2 // 从中间开始裁剪
    }

    // 绘制裁剪后的图像到canvas
    context.drawImage(
      videoDom,
      sourceX,
      sourceY,
      sourceWidth,
      sourceHeight, // 源图像裁剪区域
      0,
      0,
      canvas.width,
      canvas.height // 目标canvas区域
    )

    let data = canvas.toDataURL('image/png')
    data = data.split(',')[1]
    data = window.atob(data)
    const ia = new Uint8Array(data.length)
    for (let i = 0; i < data.length; i++) {
      ia[i] = data.charCodeAt(i)
    }

    const blobData = new Blob([ia], { type: 'image/png' })
    const blobToFile = [new window.File([blobData], 'png', { type: 'image/*' })]

    // 图片如果小于10kb不上传
    if (blobToFile[0].size < 10) {
      console.log('「截图上传」图片如果小于10不上传', blobToFile[0].size)
      return
    }

    const picUrl = await new Promise((resolve) => {
      uploadClient.fileUpload(blobToFile).then(async (result: any) => {
        const { picUrl } = result[0]
        resolve(picUrl)
      })
    })

    console.log('「截图上传」', picUrl)
    const courseId = searchParams.get('courseId') || 1000
    if (picUrl) {
      const data = {
        courseId: courseId,
        imgurl: picUrl
        // imgurl: 'https://msb-wangxiao.oss-cn-beijing.aliyuncs.com/course/1000/image/t1.jpg'
      }
      console.log('「截图上传」', data)
      controller.current = new AbortController()
      await verityRoorunWorkflowByCourseIdmUser(data, controller.current)
        .then((r) => {
          const start = isStart.get()
          if (!start) {
            return
          }
          const res = r.data
          console.log('「截图上传」上报成功', res)
          if (res.status === 0) {
            const data = res.data.data
            const fixData = JSON.parse(data)
            console.log('fixData', fixData)
            if ('result' in fixData.data.outputs && fixData.data.outputs.result.length > 0) {
              console.log('「截图上传」识别结果', fixData.data.outputs.result)
              assistantList.set(fixData.data.outputs.result)
              screenshotUploadControl.set(false)
              countdown.set(0)
            } else {
              screenshotUploadControl.set(true)
              countdown.set(Number(localStorage.COUNTDOWN_SECONDS))
            }
          } else {
            toast.error(res.msg)
            screenshotUploadControl.set(true)
            countdown.set(Number(localStorage.COUNTDOWN_SECONDS))
          }
        })
        .catch((error) => {
          console.log('error', error)
          const start = isStart.get()
          if (!start) {
            return
          }
          console.log('「截图上传」上报步骤', error)
          screenshotUploadControl.set(true)
          countdown.set(Number(localStorage.COUNTDOWN_SECONDS))
        })
    }
  }, [])

  useUpdateEffect(() => {
    if (assistantList.val.length === 0 && isStart.val) {
      screenshotUploadControl.set(true)
      countdown.set(Number(localStorage.COUNTDOWN_SECONDS))
    }
  }, [assistantList.val])

  const testData = () => {
    assistantList.set([
      {
        match_errorId: 'error01',
        match_errorName: '步骤1',
        match_errorReason: '步骤1原因',
        error_tip: '步骤1提示',
        error_guide_url: test1Img
      },
      {
        match_errorId: 'error02',
        match_errorName: '步骤2',
        match_errorReason: '步骤2原因',
        error_tip: '步骤2提示',
        error_guide_url: test2Img
      },
      {
        match_errorId: 'error03',
        match_errorName: '步骤3',
        match_errorReason: '步骤3原因',
        error_tip: '步骤3提示',
        error_guide_url: test3Img
      },
      {
        match_errorId: 'error04',
        match_errorName: '步骤4',
        match_errorReason: '步骤4原因',
        error_tip: '步骤4提示',
        error_guide_url: test4Img
      },
      {
        match_errorId: 'error05',
        match_errorName: '步骤5',
        match_errorReason: '步骤5原因',
        error_tip: '步骤5提示',
        error_guide_url: test5Img
      },
      {
        match_errorId: 'error06',
        match_errorName: '步骤6',
        match_errorReason: '步骤6原因',
        error_tip: '步骤6提示',
        error_guide_url: test6Img
      },
      {
        match_errorId: 'error07',
        match_errorName: '步骤7',
        match_errorReason: '步骤7原因',
        error_tip: '步骤7提示',
        error_guide_url: test7Img
      }
    ])
    screenshotUploadControl.set(false)
    countdown.set(0)
  }

  return (
    <div className="w-screen h-screen bg-room bg-center bg-cover bg-no-repeat overflow-x-auto overflow-y-hidden scrollbar-style flex justify-center items-center">
      <div className="w-[66vh] h-[88vh] relative">
        <div className="absolute z-50 top-0 left-0 w-full">
          <div className="w-full h-[3vh] flex items-center justify-between bg-red-400">
            <div className="flex-1 flex items-center justify-start">
              <div onClick={testData} className="bg-white text-[#000] text-[1.2vh] px-[1vh] py-[0.2vh] rounded-[0.2vh] mr-[0.2vh] anim_btn">
                测试数据
              </div>
            </div>
            <div className="flex-1 flex items-center justify-end">
              <div onClick={exit} className="bg-white text-[#000] text-[1.2vh] px-[1vh] py-[0.2vh] rounded-[0.2vh] mr-[0.2vh] anim_btn">
                退出
              </div>
            </div>
          </div>
        </div>
        {/* 助教 */}
        {isStart.val ? (
          <div className="absolute z-50 top-0 left-0 w-full">
            <div className="w-full h-[3vh] flex items-center justify-between bg-red-400">
              <div className="flex-1"></div>
              <div
                className="text-white text-[1.2vh]"
                onClick={() => {
                  localStorage.COUNTDOWN_SECONDS = Number(localStorage.COUNTDOWN_SECONDS) === 120 ? 4 : 120
                }}
              >
                AI助教，实时指导中 {countdown.val}秒 后开始截图 截图状态 {screenshotUploadControl ? '运行中' : '暂停'}
              </div>
              <div className="flex-1 flex items-center justify-end">
                <div onClick={exit} className="bg-white text-[#000] text-[1.2vh] px-[1vh] py-[0.2vh] rounded-[0.2vh] mr-[0.2vh] anim_btn">
                  退出
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* 魔法 */}
            <div className="absolute z-50 bottom-[2vh] right-[2vh] bg-white rounded-[0.4vh] overflow-hidden">
              <img onClick={() => open.set(true)} className="w-[4vh] h-[4vh]" src={magicIcon} alt="" />
            </div>
          </>
        )}
        {/* 步骤 */}
        {assistantList.val.length > 0 ? (
          <div className="absolute z-40 top-0 left-0 w-full h-full flex items-center justify-center bg-[#FF000010]">
            <div className="bg-[#ffffffaa] overflow-hidden absolute top-[40vh] left-0 z-40">
              <div className="text-[1.8vh] p-[1vh]">
                <span className="text-[3vh] text-[#FF0000]">{assistantList.val.length}</span>
                处步骤
              </div>
              <div>
                {assistantList.val.map((item, index) => (
                  <div
                    onClick={() => {
                      chooseAssistantIndex.set(index)
                    }}
                    key={index}
                    className={`text-[1.8vh] p-[0.6vh] ${chooseAssistantIndex.val === index ? 'text-[#FFF] bg-[#6361FF]' : 'text-[#6361FF]'}`}
                  >
                    {index + 1}.{item.match_errorName}
                  </div>
                ))}
              </div>
            </div>

            {chooseAssistant ? (
              <>
                <div className="w-full h-full absolute top-0 left-0 z-30 overflow-hidden">
                  <TransformWrapper
                    onInit={handleTransformInit}
                    initialScale={1}
                    minScale={0.01}
                    maxScale={5}
                    wheel={{ step: 0.1 }}
                    pinch={{ step: 5 }}
                    doubleClick={{ disabled: true }}
                    limitToBounds={false}
                    centerOnInit={true}
                  >
                    <TransformComponent wrapperClass="w-full h-full" contentClass="w-full h-full">
                      <img
                        src={chooseAssistant.error_guide_url}
                        alt=""
                        style={{
                          width: '100%',
                          height: '100%',
                          objectFit: 'contain',
                          display: 'block'
                        }}
                      />
                    </TransformComponent>
                  </TransformWrapper>
                </div>
                <div className="absolute bottom-0 left-0 z-30">
                  <div className="bg-[#ffffffaa] p-[1vh] text-[1.6vh] text-[#000] m-[0.4vh] w-[40vh]">{chooseAssistant.error_tip}</div>
                  <div className="flex">
                    <div
                      className="bg-[#6361FF] px-[1vh] py-[0.4vh] text-[1.4vh] text-[#fff] m-[0.4vh]"
                      onClick={() => {
                        assistantList.set(assistantList.val.filter((item, index) => index !== chooseAssistantIndex.val))
                        chooseAssistantIndex.set(0)
                      }}
                    >
                      跳过指导
                    </div>
                    <div
                      className="bg-[#6361FF] px-[1vh] py-[0.4vh] text-[1.4vh] text-[#fff] m-[0.4vh]"
                      onClick={() => {
                        assistantList.set(assistantList.val.filter((item, index) => index !== chooseAssistantIndex.val))
                        chooseAssistantIndex.set(0)
                      }}
                    >
                      修改完成
                    </div>
                    <div
                      className="bg-[#6361FF] px-[1vh] py-[0.4vh] text-[1.4vh] text-[#fff] m-[0.4vh]"
                      onClick={() => {
                        chooseAssistantIndex.set(-1)
                      }}
                    >
                      隐藏指导
                    </div>
                    <div
                      className="bg-[#6361FF] px-[1vh] py-[0.4vh] text-[1.4vh] text-[#fff] m-[0.4vh]"
                      onClick={() => {
                        if (transformRef.current) {
                          transformRef.current.resetTransform()
                        }
                      }}
                    >
                      重置
                    </div>
                  </div>
                </div>
              </>
            ) : null}
          </div>
        ) : null}

        {/* 视频 */}
        <div id={`video_dom`} className={`w-full h-full`}></div>
      </div>

      <Modal show={open.val} title="提示" cancel={() => open.set(false)} confirm={start}>
        <div className="py-[20px]">
          <p className="text-[14px]"> 确定开启AI助教实时指导？</p>
          <p className="text-[14px]">开启后请不要随意挪动摄像头位置</p>
        </div>
      </Modal>

      {/* 助教 */}
      {/* <Assistant /> */}
      <div className="fixed z-50 bottom-0 h-[16px] w-screen text-center text-[12px] text-[rgba(255,255,255,0.3)] text-s">{import.meta.env.VITE_APP_TIME}</div>
    </div>
  )
}
